var map = {
	"./assorted-dressed-foods.jpg": 81,
	"./bed-and-breakfast.jpg": 82,
	"./bread-brunch-lunch.jpg": 83,
	"./bread-brunch-table.jpg": 84,
	"./carbonara-in-gray-bowl.jpg": 85,
	"./close-up-flower-cake.jpg": 86,
	"./coconut-filled-with-strawberry.jpg": 87,
	"./crushed-food.jpg": 88,
	"./cuisine.jpg": 89,
	"./egg-toast.jpg": 90,
	"./fig-toast.jpg": 91,
	"./fork-and-knife-on-white-ceramic-plate.jpg": 92,
	"./fruits-platter.jpg": 93,
	"./ice-cream-cups.jpg": 94,
	"./lemon-pie.jpg": 95,
	"./oven-fig-toasts.jpg": 96,
	"./sauce-pan-filled-with-cooked-food.jpg": 97,
	"./shallow-focus-of-strawberry-patisseries.jpg": 98
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;